import { FormControlLabel, FormHelperText, Radio, RadioGroup, Tooltip } from "@mui/material";
import React, { ChangeEventHandler, type JSX } from 'react';
import { Controller, useFormContext } from "react-hook-form";
import { FormFieldPropsBase } from "../form/Form";

export type FormRadioGroupRadioButton = {
    label: string | JSX.Element | null;
    ariaLabel?: string;
    helperText?: string;
    value: string | number;
    disabled?: boolean;
    tooltip?: string | JSX.Element;
};

export type FormRadioGroupProps = {
    radioButtons: FormRadioGroupRadioButton[];
    rules?: any;
    onChanging?: (toValue: string | number, fromValue: string | number) => Promise<boolean>;
    onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
    direction?: "column" | "row";
} & FormFieldPropsBase;

export default function FormRadioGroup({
    name,
    //id,
    //testId,
    label,
    ariaLabel,
    readOnly,
    helperText,
    sx,
    radioButtons,
    disabled,
    rules,
    onChanging,
    onChange,
    direction
}: FormRadioGroupProps) {
    const { control } = useFormContext();

    function toButtonValueType(value: string): number | string {
        // Find the radio button definition corresponding to the current value.
        // If its value is of type numeric then return a number, otherwise
        // return a string.
        const button = radioButtons.find(rb => rb.value.toString() === value);
        return typeof (button?.value) === "number"
            ? parseInt(value, 10)
            : value;
    }

    return (
        <>
            <label>{label}</label>
            <Controller
                control={control}
                name={name}
                rules={rules}
                render={
                    ({
                        field: {
                            ref,
                            name,
                            value,
                            onChange: onFieldChange,
                            onBlur
                        },
                        fieldState: {
                            invalid,
                            isTouched,
                            isDirty,
                            error
                        },
                        formState
                    }: {
                        field: any;
                        fieldState: any;
                        formState: any;
                    }) => (
                        <>
                            <RadioGroup aria-label={ariaLabel ?? undefined}
                                ref={ref}
                                value={value}
                                onChange={
                                    async (e) => {
                                        const toValue = toButtonValueType(e.target.value);

                                        if (!onChanging || (await onChanging(toValue, value))) {
                                            onFieldChange(toValue);
                                            onChange && onChange(e);
                                        }
                                    }
                                }
                                row={direction === "row"}
                            //{...field}
                            >

                                {radioButtons.map((item, index) => (
                                    <React.Fragment key={`${index}`}>
                                        <Tooltip title={item.tooltip} arrow>
                                            <FormControlLabel
                                                //aria-label={item.ariaLabel}
                                                sx={{
                                                    marginTop: 0,
                                                    ...sx
                                                }}
                                                value={item.value}
                                                control={<Radio //color='secondary'
                                                    // readonly does nothing on this control readOnly={readOnly}
                                                    disabled={disabled || readOnly || item.disabled}
                                                    slotProps={{
                                                        input: { 'aria-label': item.ariaLabel }
                                                    }}
                                                />}
                                                label={item.label} />
                                        </Tooltip>                                 
                                        {item.helperText &&
                                            <FormHelperText>
                                                {item.helperText}
                                            </FormHelperText>
                                        }
                                    </React.Fragment>
                                ))}

                            </RadioGroup>
                        </>
                    )
                }
            />
        </>
    );
}
